
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/places",
      function () {
        return require("private-next-pages/places/index.tsx");
      }
    ]);
  